export const encryptData: any = (value: string) => {

    return value;
}

export const decryptData: any = (value: string) => {

    return value;
}